import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  isDevMode,
  APP_INITIALIZER,
  ErrorHandler,
} from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RedirectionComponent } from './component/error/redirection/redirection.component';
import { ServiceWorkerModule } from '@angular/service-worker';
let sentryErrorHandler: any = null;
let sentryTraceService: any = null;

async function initSentryServices() {
  try {
    const Sentry = await import('@sentry/angular');

    sentryErrorHandler = Sentry.createErrorHandler({
      showDialog: false,
    });

    sentryTraceService = Sentry.TraceService;

    return {
      errorHandler: sentryErrorHandler,
      traceService: sentryTraceService,
    };
  } catch (error) {
    console.warn('Sentry services failed to load:', error);
    return { errorHandler: null, traceService: null };
  }
}

class FallbackErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('Global error:', error);
  }
}

import { DashboardModule } from './component/dashboard/dashboard.module';
import { EnddetailsModule } from './component/enddetails/enddetails.module';

import { HttpInterceptorInterceptor } from './interceptors/http-interceptor.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { WidgetContainerModule } from './component/widget-container/widget-container.module';
import { PopupExclusiveDealsModule } from './component/popups/popup-exclusive-deals/popup-exclusive-deals.module';

@NgModule({
  declarations: [AppComponent, RedirectionComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DashboardModule,
    EnddetailsModule,
    WidgetContainerModule,
    PopupExclusiveDealsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWithDelay:5000',
    }),
  ],
  providers: [
    provideClientHydration(),

    {
      provide: ErrorHandler,
      useClass: FallbackErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        return () => Promise.resolve();
      },
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorInterceptor,
      multi: true,
    },
    CookieService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor() {
    setTimeout(async () => {
      try {
        const services = await initSentryServices();
      } catch (error) {
        console.warn('Failed to load Sentry services:', error);
      }
    }, 3000);
  }
}
